import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { IsAccountValidGuard } from './base/is-account-valid.guard';
import { LoadDomainGuard } from './base/load-domain.guard';
import { LoadServicesGuard } from './base/load-services.guard';
import { isPlatformServer } from '@angular/common';
import { SEOService } from '../services/seo.service';

@Injectable({
  providedIn: 'root'
})
export class SignupGuardCanActivateGuard  {

  constructor(
    private isAccountValidGuard: IsAccountValidGuard,
    private loadDomainGuard: LoadDomainGuard,
    private loadServicesGuard: LoadServicesGuard,
    private seoService: SEOService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivateChild(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      this.seoService.setMetasSignup();
      return of(true);
    }
    return this.loadDomainGuard.canActivate().pipe(mergeMap((domainLoaded: boolean) => {
      if (domainLoaded) {
        return this.loadServicesGuard.canActivate().pipe(mergeMap((servicesLoaded: boolean) => {
          if (servicesLoaded) {
            return this.isAccountValidGuard.canActivate().pipe(mergeMap((isAccountValid: boolean) => {
              return of(isAccountValid);
            }));
          }
        }));
      }
    }));
  }
}
